module.exports = __webpack_public_path__ + "img/grillentanz3.dec04536.jpg";